"use strict";

var _vuePropertyDecorator = require("vue-property-decorator");

_vuePropertyDecorator.Component.registerHooks(['beforeRouteEnter', 'beforeRouteUpdate', 'beforeRouteLeave']);